import React from 'react';
import { BrandId } from '../../../../utils/override';
import { ComparisonTableWrapper } from '../components-internal/ComparisonTable/ComparisonTableWrapper';
import { ProductListing } from '../components-internal/ProductListing';
import { getLoanSearchParamsWithDefaultComponentParam } from '../helpers/loanSearchParams';
import { PageType, VerticalType } from '../types';
import { usePageDataContext } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import {
  ComponentSelectedProducts,
  EnumDisplayType,
} from '$/(cms)/_modules/cmsService/types';
import { ProductComparisonTable } from '$/components/cms/components-internal/ProductComparisonTable';
import { ProductComparisonTableTravelInsurance } from '$/components/cms/components-internal/ProductComparisonTableTravelInsurance';

export const SelectedProducts: React.FC<
  ComponentSelectedProducts & {
    slug?: string;
    vertical?: VerticalType;
    pageType: PageType;
    index?: number;
    brand: BrandId;
  }
> = (props) => {
  const { pageType } = usePageDataContext();

  switch (props.vertical) {
    case 'CREDIT_CARD':
      switch (props.display_type) {
        case EnumDisplayType.ProductListing:
          return <ProductListing {...props} />;
        case EnumDisplayType.ComparisonTable:
          return (
            <ComparisonTableWrapper
              tableConfig={{
                id: props.id,
                titleReq: props.titleReq,
                attributes: props.attributes,
                min_loan_amount: props.min_loan_amount,
                max_loan_amount: props.max_loan_amount,
                min_loan_tenure: props.min_loan_tenure,
                max_loan_tenure: props.max_loan_tenure,
                default_loan_amount: props.default_loan_amount,
                default_loan_tenure: props.default_loan_tenure,
                maxVisibleProducts: 8,
                baseColumnOrder: undefined,
                visible: props.visible,
                visible_mobile: props.visible_mobile,
              }}
              products={props.products || []}
              vertical={props.vertical}
              slug={props.slug}
              pageType={pageType}
              tabs={undefined}
            />
          );
      }
      break;

    case 'PERSONAL_LOANS': {
      const loanSearchParams = getLoanSearchParamsWithDefaultComponentParam(
        props.brand,
        undefined,
        {
          amount: props.default_loan_amount
            ? props.default_loan_amount.toString()
            : undefined,
          tenure: props.default_loan_tenure
            ? props.default_loan_tenure.toString()
            : undefined,
        },
      );
      // todo request initial data
      switch (props.display_type) {
        case EnumDisplayType.ProductListing:
          return (
            <ProductListing {...props} loanSearchParams={loanSearchParams} />
          );
        case EnumDisplayType.ComparisonTable:
          return (
            <ComparisonTableWrapper
              tableConfig={{
                id: props.id,
                titleReq: props.titleReq,
                attributes: props.attributes,
                min_loan_amount: props.min_loan_amount,
                max_loan_amount: props.max_loan_amount,
                min_loan_tenure: props.min_loan_tenure,
                max_loan_tenure: props.max_loan_tenure,
                default_loan_amount: props.default_loan_amount,
                default_loan_tenure: props.default_loan_tenure,
                maxVisibleProducts: 8,
                baseColumnOrder: undefined,
                visible: props.visible,
                visible_mobile: props.visible_mobile,
              }}
              products={props.products || []}
              vertical={props.vertical}
              slug={props.slug}
              loanSearchParams={loanSearchParams}
              pageType={pageType}
              tabs={undefined}
            />
          );
      }
      break;
    }

    case 'TRAVEL_INSURANCE': {
      switch (props.display_type) {
        case EnumDisplayType.ProductListing:
          return <ProductListing {...props} />;
        case EnumDisplayType.ComparisonTable:
          return (
            <ProductComparisonTableTravelInsurance
              tableConfig={{
                titleReq: props.titleReq,
                attributes: props.attributes,
              }}
              products={props.products || []}
            />
          );
      }
      break;
    }

    default: {
      switch (props.display_type) {
        case EnumDisplayType.ProductListing:
          return <ProductListing {...props} />;
        case EnumDisplayType.ComparisonTable:
          return (
            <ProductComparisonTable
              tableConfig={{
                titleReq: props.titleReq,
                attributes: props.attributes,
                visible_mobile: props.visible_mobile,
              }}
              products={props.products || []}
            />
          );
      }
      break;
    }
  }
};
